'use client'

import dynamic from 'next/dynamic'
import { useEffect, useRef } from 'react'

import usePx from '@src/quince-site-common/src/hooks/usePx'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

function QRCanvasComponent({
  url,
  widthInRem,
  className,
  margin = 4,
}: {
  url: string
  widthInRem: number
  className?: string
  /** Quiet-zone size in modules. Default 4 (qrcode library default). Pass 1 when the
   *  surrounding container already provides whitespace via padding. */
  margin?: number
}) {
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const getPxFromRem = usePx()
  const widthInPx = getPxFromRem(widthInRem, false)

  useEffect(() => {
    const generateQR = async () => {
      if (canvasRef.current) {
        const { toCanvas } = await import(/* webpackChunkName: "qrcode" */ 'qrcode')
        try {
          await toCanvas(canvasRef.current, url, {
            width: widthInPx,
            margin,
          })
          trackEvent(TELEMETRY_EVENT_NAMES.QR_RENDERED_SUCCESS, {})
        } catch {
          trackEvent(TELEMETRY_EVENT_NAMES.QR_RENDERED_ERROR, {})
        }
      }
    }
    void generateQR()
  }, [url, widthInPx, margin])

  return <canvas ref={canvasRef} width={widthInPx} height={widthInPx} className={className} />
}

export default dynamic(() => Promise.resolve(QRCanvasComponent), {
  ssr: false,
})
